import moment from 'moment'
import { range, keyBy, values } from 'lodash' 

import createDuck from '../lib/MetagnosticDuck'
import ActionTypes from '../actions/ActionTypes.js'
import getPlansList from '../tasks/plans'
import { getTask, getTasks } from '../lib/APIClient'
import { randstr } from '../../lib/Tools'

export type Task = {
  _id: string, 
  text: string, 
  status: "pending"|"done"|"failed"|"passed",
  dueDate: ?string, // YYYY-MM-DD
  type: "call"|"msg"|"other", 
  user: string, 
  trip: ?string,
  creation: string, 
  modification: ?string,
  plan: ?string
}

export const emptyTask: Task = {
  /* id, */
  /* user, */
  text: "", 
  status: "pending", 
  dueDate: null, 
  type: "other", 
  trip: null, 
  user: null, 
  creation: "1970/01/01", 
  modification: null, 
  plan: null
}

function getTasksList(
  id: string[], plan: string, trip: string, startDate: string|Object, encargado: string
): Object[] {
  const ts = moment().format("YYYY/MM/DD")
  
  return getPlansList()[plan].make(trip, startDate, encargado)
    .map((partial, i) => ({
      //getNewTask(id[i], partial))
      ...emptyTask, 
      ...partial, 
      _id: id[i], 
      creation: ts, 
      modification: ts, 
    }))
}

// const createDuck = (name, getDoc, getCollection, customActions, emptyDoc, customReducers = {}, opt = null) => ({

const duck = createDuck(
  "TASKS", 
  getTask, 
  getTasks, 
  {
    // custom actions
    initiatePlan: (trip: string, planId: string, encargado: string, startDate: Object|string) => {
      const plan = getPlansList()[planId]
      const id = range(plan.length).map(() => randstr(16))

      return { 
        type: ActionTypes.INITIATE_PLAN, 
        id, // ARRAY!
        payload: {
          trip, plan: planId, encargado, startDate
        }
      }
    },
    cancelTripTasks : (tripId: string) => (dispatch, getState) => {
      dispatch({
        type: ActionTypes.UPDATE_MANY_TASKS,
        id : values(getState().tasks).filter(task => task.trip == tripId && task.status == "pending").map(task => task._id),
        payload : {status : "passed"}
      })
    }
  }, 
  emptyTask, 
  {
    // custom reducers
    [ActionTypes.INITIATE_PLAN]: (state, action) => {
      const { trip, startDate, encargado, plan } = action.payload
      const newTasks = getTasksList(action.id, plan, trip, startDate, encargado)

      return {
        ...state, 
        ...keyBy(newTasks, "_id")
      }
    },
  }, 
  { 
    expunge: true, 
    extraCreateActions: [ActionTypes.INITIATE_PLAN], 
  }
)

export const createTask = duck.actions.createDoc
export const receiveTasks = duck.actions.receiveCollection
export const receiveTask = duck.actions.receiveDoc
export const removeTask = duck.actions.removeDoc
export const fetchTasks = duck.actions.fetchCollection
export const updateTask = duck.actions.updateDoc
export const cancelTripTasks = duck.actions.cancelTripTasks
export const initiatePlan = duck.actions.initiatePlan

// this isn't inside the duck, but defined outside, just because it needs to access `createTask`. IDK how I'll solve this kind of case
// @WARNING action (or a variant of one) defined outside the duck
export const createTaskForThisUser = (initials, cb) => (dispatch, getState) => (
  dispatch(duck.actions.createDoc({ 
    ...initials, 
    user: getState().loginData.username
  }, cb))
)

export default duck

